(function () {
  'use strict';

  /* @ngdoc object
   * @name crewPairingReport
   * @description
   *
   */
  angular
    .module('crewPairingReport', [
      'ui.router'
    ]);
}());
